<template>
  <!-- Start Main Banner -->
  <div class="main-banner">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-5">
              <div class="hero-content">
                <h1>Digital Product Studio and IT Consulting</h1>
                <p>
                  Interactive Information Systems provides Information Technology (I.T.) services to businesses,
                  foundations, public institutions, and government entities. Services include software, web,
                  and database development custom-designed to improve the efficiency, integrity, and security of your business.
                  <br />
                  <br />Interactive software and infrastructure solutions will improve your workflow and system security now and prepare your organization for the future.
                  Industry standards and best practices are incorporated into custom solutions to guarantee compatibility with current and future technologies.
                </p>
              </div>
            </div>

            <div class="col-lg-5 offset-lg-1">
              <div class="banner-form ml-3">
                <form
                  name="interactive_is_contactform"
                  action="/thanks"
                  method="post"
                  netlify
                  netlify-honeypot="bot-field"
                >
                  <input type="hidden" name="form-name" value="interactive_is_contactform" />
                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label>Name</label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          class="form-control"
                          required
                          data-error="Please enter your name"
                          placeholder="Name"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          class="form-control"
                          required
                          data-error="Please enter your email"
                          placeholder="Email"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label>Message</label>
                        <textarea
                          name="message"
                          class="form-control"
                          id="message"
                          cols="30"
                          rows="5"
                          required
                          data-error="Write your message"
                          placeholder="Your Message"
                        ></textarea>
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <button type="submit" class="btn btn-primary">Send Message</button>
                      <div id="msgSubmit" class="h3 text-center hidden"></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Main Banner -->
</template>

<script>
import axios from "axios";

export default {
  name: "Banner",
  data() {
    return {
      form: {
        askPerson: ""
      }
    };
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit() {
      const axiosConfig = {
        header: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      axios.post(
        "/",
        this.encode({
          "form-name": "ask-question",
          ...this.form
        }),
        axiosConfig
      );
    }
  }
};
</script>